module.exports = __webpack_public_path__ + "img/guide-suggestion.8efc45a6.gif";